import { LOCALE_US } from 'dibs-intl/exports/locales';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { getSponsoredLabelAbTestVariant } from './abTestHelpers.ts';

const messages = defineMessages({
    sponsoredLabel: {
        id: 'dc.sponsoredAds.sponsoredLabel',
        defaultMessage: 'Sponsored',
    },
    boostedLabel: {
        id: 'dc.sponsoredAds.boostedLabel',
        defaultMessage: 'Boosted',
    },
    promotedBySellerLabel: {
        id: 'dc.sponsoredAds.promotedBySellerLabel',
        defaultMessage: 'Promoted by Seller',
    },
});

export const useSponsoredLabel = ({
    isClient,
}: {
    isClient: boolean | null | undefined;
}): string => {
    const { formatMessage, locale } = useIntl();

    if (!isClient) {
        // Render sponsored label on client side
        return '';
    }

    if (locale !== LOCALE_US) {
        // Render default sponsored label in non-US locales
        return formatMessage(messages.sponsoredLabel);
    }

    const abTestVariant = getSponsoredLabelAbTestVariant();
    if (abTestVariant === 'variant') {
        return formatMessage(messages.promotedBySellerLabel);
    } else if (abTestVariant === 'variant-b') {
        return formatMessage(messages.boostedLabel);
    }

    return formatMessage(messages.sponsoredLabel);
};
